import React, { useState } from "react";
import {
  getOwnerAddress,
  setRewardWallets
} from "../../../services/getWeb3";

const RewardWalletChange = () => {
  const [firstWallet, setfirstWallet] = useState("");
  const [secondWallet, setsecondWallet] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!firstWallet || !secondWallet) {
      alert("Please fill in both wallet addresses.");
      return;
    }
  
    try {
      // Optional: Show a loader or disable the button here
      console.log("Sending transaction to change reward wallet...");
  
      const tx = await setRewardWallets(firstWallet, secondWallet);
      await tx.wait(); // Wait for confirmation
  
      alert("Reward wallet changed successfully!");
      setfirstWallet("");
      setsecondWallet("");
    } catch (error) {
      console.error("Error changing reward wallet:", error);
      alert("Failed to change reward wallet. See console for details.");
    } finally {
      // Optional: Stop loader or re-enable button here
    }
  };
  

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-primary text-white">
              <h5 className="mb-0 text-light">Reward Wallet Change</h5>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="oldWallet" className="form-label">
                    First Wallet Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="oldWallet"
                    value={firstWallet}
                    onChange={(e) => setfirstWallet(e.target.value)}
                    placeholder="Enter first wallet address"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="newWallet" className="form-label">
                    Second Wallet Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="newWallet"
                    value={secondWallet}
                    onChange={(e) => setsecondWallet(e.target.value)}
                    placeholder="Enter second wallet address"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100">
                  Change Reward Wallet
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardWalletChange;
